import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { QuizComponent } from './quiz/quiz.component';
import { ShoeCardComponent } from './shoe-card/shoe-card.component';
import { SpeedShoesComponent } from './speed-shoes/speed-shoes.component';
import { CushionShoesComponent } from './cushion-shoes/cushion-shoes.component';
import { StabilityShoesComponent } from './stability-shoes/stability-shoes.component';
import { SearchComponent } from './search/search.component';
import { HttpClientModule } from '@angular/common/http';
import { SearchShoeCardComponent } from './search-shoe-card/search-shoe-card.component';
import { FavoriteShoeCardComponent } from './favorite-shoe-card/favorite-shoe-card.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { FavoritesListComponent } from './favorites-list/favorites-list.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgxSpinnerModule } from "ngx-spinner";
import { NoopAnimationsModule } from '@angular/platform-browser/animations'
import { TrackMyWorkoutComponent } from './track-my-workout/track-my-workout.component';
import { ChooseYourWorkoutComponent } from './choose-your-workout/choose-your-workout.component';
import { YourWorkoutPlanComponent } from './your-workout-plan/your-workout-plan.component';
import { YourRunningWorkoutPlanComponent } from './your-running-workout-plan/your-running-workout-plan.component';

// Firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { AngularFireAuth } from '@angular/fire/auth';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    QuizComponent,
    ShoeCardComponent,
    SpeedShoesComponent,
    CushionShoesComponent,
    StabilityShoesComponent,
    SearchComponent,
    SearchShoeCardComponent,
    FavoriteShoeCardComponent,
    SearchResultsComponent,
    FavoritesListComponent,
    TrackMyWorkoutComponent,
    ChooseYourWorkoutComponent,
    YourWorkoutPlanComponent,
    YourRunningWorkoutPlanComponent
  ],
  imports: [
    NgbModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NoopAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule, 
  ],
  providers: [AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
